/*
 * @Author: wzc
 * @Date: 2024-06-29 10:42:36
 * @LastEditors: wzc
 * 羽毛球 汤尤杯 抽离容器.vue文件中共用的属性和方法
 * @LastEditTime: 2024-06-29 19:11:02
 */

import platfrom_menu from '@components/base/menu'
import publicThemeDialog from '@components/base/theme/publicThemeDialog.vue'
import containerFull_common_data_mixin from '@mixins/containerFull_common_data'
import platfrom_createThemeItem_data_mixin from '@mixins/platfrom_createThemeItem_data'
import { https_manage_getGroupData } from '@api/platfrom_base_api'
import { https_badminton_seasonList } from '@api/platfrom_badminton_api'

export default {
  name: 'containerFull_badminton',
  mixins: [
    containerFull_common_data_mixin,
    platfrom_createThemeItem_data_mixin,
  ],
  components: {
    platfrom_menu,
    publicThemeDialog,
  },
  data() {
    return {
      currCid: null,
      currSid: null,
      currSeasonName: null,
      dynamicConfig: null,
      sportsTypeArr: ['combat', 'uncombat'],
      platfromMenu_selectData: [],
      platfromMenu_userInfor: {
        companyName: '',
        email: '',
        identy: '',
        role: '',
        station: null,
        stationName: '',
        userAlias: '',
        userId: '',
      },
      platfromMenu_groupList: [],
      platfromMenu_currGroup: null,
      containThemeRouteName: [
        // 当组id变化时，这些页面重新加载数据
      ],
      containerFull_curPageInitNum: 0,
      isShowPublicThemeDialog: false,
      publicThemeDialogObj: null,
      popInfor: {
        infor: '',
        btnName: '加载',
      },
      platfromMenu_timeZoneFlag: true, // true: 北京时区；false:当地时区
      platfromMenu_curTimeZoneItem: {
        name: '北京时间',
        val: 'beijing',
      },
    }
  },
  watch: {
    $route(to, from) {
      // 如果是从b到a页面，则不缓存b
      // 注意 路由那么要与组件name一致
      console.debug(from.name, to.name)
    },
  },
  created() {
    this.init()
  },
  methods: {
    platfrom_changeSid(sid) {
      this.currSid = sid
    },
    changeSidToInitPage(num) {
      this.containerFull_curPageInitNum = num
    },
    platfromMenu_timeZoneFlagEvent(data) {
      console.debug('platfromMenu_timeZoneFlagEvent:', data)
      if (data) {
        this.platfromMenu_timeZoneFlag = data.val
        this.platfromMenu_curTimeZoneItem = data.item
      }
    },
    platfromMenu_changeGroup(item) {
      this.platfromMenu_groupList.forEach((val) => {
        if (item.groupId == val.groupId) {
          val.act = true
        } else {
          val.act = false
        }
      })
      this.platfromMenu_currGroup = item
      window.mixtmt_platfrom.currGroup = item
    },
    async init() {
      const userInfor = JSON.parse(
        this.$localStorage.getItem('mixtmt_userInfo')
      )
      if (userInfor) {
        this.platfromMenu_userInfor = userInfor
      }
      if (!window.mixtmt_platfrom.currGroup) {
        // 防止在大运会中刷新页面，没有组数据
        await this.getGroupData()
      } else {
        this.platfromMenu_currGroup = window.mixtmt_platfrom.currGroup
      }

      const groupList = JSON.parse(
        this.$localStorage.getItem('mixtmt_groupList')
      )
      if (groupList) {
        // 防止在home页切换组别，马拉松没有同步
        this.platfromMenu_groupList = groupList
        this.platfromMenu_groupList.forEach((val) => {
          if (this.platfromMenu_currGroup.groupId == val.groupId) {
            val.act = true
          } else {
            val.act = false
          }
        })
      }
      // 获取赛季列表
      await this.getSeasonList({ cid: this.currCid })
    },
    async getSeasonList(query) {
      await https_badminton_seasonList(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.platfromMenu_selectData = res.data
              ? res.data.map((val, index) => ({
                  cid: query.cid,
                  name: val.seasonName,
                  key: val.seasonId,
                  logoImage: val.seasonLogo,
                  act: this.currSid
                    ? this.currSid == val.seasonId
                      ? true
                      : false
                    : index == 0
                    ? true
                    : false,
                }))
              : []
            // this.currSid = 1072020
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getGroupData() {
      await https_manage_getGroupData('/api', this.$axios)
        .then((response) => {
          const res = response.data
          console.debug('正常')
          if (res.status === 0) {
            // 测试切换组
            // res.data = res.data.concat({
            //   groupId: '06476a49-3db4-4b4c-91b3-b228714d6000',
            //   groupName: '测试切换',
            // })

            this.platfromMenu_groupList = res.data
              ? res.data.map((item, index) => {
                  if (index == 0) {
                    item.act = true
                    this.platfromMenu_currGroup = item
                    window.mixtmt_platfrom.currGroup = item
                  } else {
                    item.act = false
                  }
                  return item
                })
              : []
            this.$localStorage.setItem(
              'mixtmt_groupList',
              JSON.stringify(res.data)
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
